import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  SaveButton,
  SubmitButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Autocomplete, Box, Button, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { addPermission } from "../../../redux/features/permissionSlice";
import {
  changeUser,
  fetchAlldepartments,
  fetchUserunderdepartment,
  getSale,
} from "../../../redux/features/assetManagementSlice";
import { Icon } from "@iconify/react/dist/iconify.js";

const ChangeUser = ({ dispatchParams, saleId }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, allDepartments, usersunderdpt } = useSelector(
    (state) => state.assetmanagement
  );

  const ValidationSchema = Yup.object().shape({
    department_id: Yup.string().required("Choose a department"),
    userId: Yup.string().required("Select a user"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      userId: "",
      saleId: saleId,
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(changeUser(values)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getSale(dispatchParams));
          formik.resetForm();
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          formik.resetForm();
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    if (open) dispatch(fetchAlldepartments());
  }, [open]);

  useEffect(() => {
    if (formik.values.department_id) {
      dispatch(fetchUserunderdepartment(formik.values.department_id));
    }
  }, [formik.values.department_id]);

  const handledepartment = (e, option) => {
    formik.setFieldValue("department_id", option?.dept_id);
  };
  const handleUserChange = (e, option) => {
    formik.setFieldValue("userId", option?.userID);
  };

  return (
    <GlobalDialog
      title={"Change User"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <Button
          sx={{
            p: "7px 10px",
            gap: "5px",
            background:
              "linear-gradient(108deg,rgb(21, 89, 184),rgba(40, 37, 226, 0.32))",
            color: "#fff",
            "&:hover": {
              background:
                "linear-gradient(108deg,rgb(117, 43, 191),rgba(121, 19, 172, 0.32))",
            },
          }}
          variant="contained"
          disabled={false}
          onClick={() => setOpen(true)}
        >
          <Icon icon="flowbite:user-solid" width={25} height={25} />
          Change User
        </Button>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <Autocomplete
                    fullWidth
                    name="department_id"
                    options={allDepartments}
                    getOptionLabel={(option) => option.dept_name || ""}
                    value={
                      allDepartments?.find(
                        (d) => d?.dept_id == formik.values.department_id
                      ) || null
                    }
                    onChange={handledepartment}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="Department"
                        error={
                          formik.touched.department_id &&
                          Boolean(formik.errors.department_id)
                        }
                        helperText={
                          formik.touched.department_id &&
                          formik.errors.department_id
                        }
                      />
                    )}
                  />
                  <Autocomplete
                    fullWidth
                    name="userId"
                    options={usersunderdpt}
                    onChange={handleUserChange}
                    getOptionLabel={(option) => option.name || ""}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="User"
                        error={
                          formik.touched.userId && Boolean(formik.errors.userId)
                        }
                        helperText={
                          formik.touched.userId && formik.errors.userId
                        }
                      />
                    )}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Submit"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default ChangeUser;
